import gql from 'graphql-tag';

export const GET_EVENT_QUERY = gql`
  query GetEvent($id: ID!) {
    event(id: $id) {
      id
      name
      description

      page {
        id
        title
      }

      place {
        id
        name
      }

      eventOccurrences(first: 40) {
        edges {
          node {
            startsAt
            duration
          }
        }
      }

      images {
        image {
          id
          url
        }
        type
      }

      tags {
        id
        name
      }
    }
  }
`;
